export default __webpack_public_path__ + "static/media/email.ba0a20f7.svg";